import React from 'react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white py-10" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-104">
          <div className="mb-6 md:mb-0 flex items-center" data-id="element-105">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/94FeEkqdPVwHspatpPFpjZ/499458431_122108209478871706_5858944869094991694_n.jpg" alt="Bivek Logo" className="h-10 bg-white p-1 rounded" data-id="element-106" />
            <div className="ml-3" data-id="element-107">
              <h2 className="text-lg font-bold" data-id="element-108">BIVEK</h2>
              <p className="text-xs text-gray-400" data-id="element-109">Mööblipaigaldus</p>
            </div>
          </div>
          <div className="text-center md:text-right" data-id="element-110">
            <p data-id="element-111">Mööbli montaaž ja paigaldus Viljandimaal ja üle Eesti</p>
            <p className="text-sm text-gray-400 mt-2" data-id="element-112">
              © {currentYear} Bivek Mööblipaigaldus. Kõik õigused kaitstud.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;